import { Link, useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSeo } from "../hooks/useSeo";
import { buildCanonicalUrl } from "../seo/config";
import type { LayoutOutletContext } from "../layout/types";

export const NotFound = () => {
  const { t } = useTranslation();
  const { localePrefix, locale } = useOutletContext<LayoutOutletContext>();
  const pageTitle = t("pages.notFound.title");
  const siteTitle = t("site.title");

  useSeo({
    title: `${pageTitle} | ${siteTitle}`,
    description: t("pages.notFound.description"),
    canonical: buildCanonicalUrl("404/", locale),
    noindex: true,
    locale,
  });
  const base = localePrefix ? `/${localePrefix}` : "";

  return (
    <article className="page page--not-found">
      <header className="page__header">
        <h1 className="page__title">{pageTitle}</h1>
        <p className="page__intro">{t("pages.notFound.description")}</p>
      </header>
      <div className="page__cta">
        <Link to={`${base}/`} className="button-link">
          {t("pages.notFound.cta")}
        </Link>
      </div>
    </article>
  );
};
